export default __webpack_public_path__ + "static/media/londres-2x.a8c148e0.webp";